import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "EntitySelection" }
const _hoisted_2 = { class: "ConfigurationBlock" }
const _hoisted_3 = {
  key: 0,
  class: "ConfigurationBlockList"
}
const _hoisted_4 = ["onChange"]
const _hoisted_5 = ["checked"]
const _hoisted_6 = { class: "EntityTypeBlock" }
const _hoisted_7 = { class: "ConfigurationBlockOptionEntityDetails" }
const _hoisted_8 = { class: "ConfigurationBlockOptionId" }
const _hoisted_9 = {
  key: 1,
  class: "ConfigurationBlockList"
}
const _hoisted_10 = { class: "ShortcutsBlock TopEntityShortcutsBlock" }
const _hoisted_11 = { class: "SelectionDetailsBlock" }
const _hoisted_12 = { class: "SelectionDetailsCounterBlock" }
const _hoisted_13 = {
  key: 0,
  class: "SelectionDetailsWarningMessage"
}
const _hoisted_14 = { class: "ShortcutsBlock" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EntitySelectionFilters = _resolveComponent("EntitySelectionFilters")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.postData)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_EntitySelectionFilters, {
            onPricingFilterSelectionChanged: _ctx.setPricingFilterSelection,
            onDegreeFilterSelectionChanged: _ctx.setDegreeFilterSelection
          }, null, 8 /* PROPS */, ["onPricingFilterSelectionChanged", "onDegreeFilterSelectionChanged"]),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.detailsOfRelevantEntities.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsOfRelevantEntities, (detailsOfEntity) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "ConfigurationBlockOption",
                      key: detailsOfEntity.id
                    }, [
                      _createElementVNode("label", {
                        onChange: ($event: any) => (_ctx.updateEntitySelection(detailsOfEntity)),
                        class: "ConfigurationBlockOptionLabel"
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "ConfigurationBlockOptionCheckbox",
                          checked: _ctx.isEntitySelected(detailsOfEntity)
                        }, null, 8 /* PROPS */, _hoisted_5),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.retrieveEntityType(detailsOfEntity)), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_7, [
                          (_ctx.isEntityTypeStudy(detailsOfEntity))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass([
										'EntityTypeLabel',
										_ctx.retrieveEntityClassName(detailsOfEntity)
									])
                              }, _toDisplayString(detailsOfEntity.degreeName) + " ", 3 /* TEXT, CLASS */))
                            : _createCommentVNode("v-if", true),
                          _createTextVNode(_toDisplayString(detailsOfEntity.title) + " (", 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(detailsOfEntity.id), 1 /* TEXT */),
                          _cache[2] || (_cache[2] = _createTextVNode(") ", -1 /* CACHED */))
                        ])
                      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_4)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("p", { class: "NoCountriesFoundText" }, " No studies or organisations were found that match the selected filter options. ", -1 /* CACHED */)
                ]))]))
          ]),
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", {
              class: "Shortcut",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectAllEntities()))
            }, " Select all studies and organisations ")
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", {
                class: _normalizeClass([
						'SelectionDetailsCounterNumber',
						!_ctx.detailsOfSelectedEntities.length ? 'NoSelection' : ''
					])
              }, _toDisplayString(_ctx.detailsOfSelectedEntities.length), 3 /* TEXT, CLASS */),
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "studies and organisations selected.", -1 /* CACHED */))
            ]),
            (!_ctx.doSelectedEntitiesHaveTheSameConfiguration)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "lnr-warning SelectionWarningIcon" }, null, -1 /* CACHED */),
                  _createElementVNode("span", null, " The selected organisations and studies do not have the same settings. If targeting and pricing changes on the next screens are saved, they will overwrite existing settings for all selected entities. ", -1 /* CACHED */)
                ]))]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("ul", _hoisted_14, [
            _createElementVNode("li", {
              class: "Shortcut",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deselectAllEntities()))
            }, " Clear selection ")
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}